var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"w-full h-16 bg-indigo-900"},[_vm._v("Header area")])}
var staticRenderFns = []

export { render, staticRenderFns }